module.exports = __webpack_public_path__ + "img/bst_ch_morghur_0.bc0fbc48.png";